import PropTypes from 'prop-types';
import ToggleSwitch from '../../form/ToggleSwitch/ToggleSwitch';
import styles from './Header.module.css';

function Header({ isMRV = true, onCompanyToggle }) {
  return (
    <header>
      <div className={styles.container}>
        <div className={styles.logo}>
          <img
            src={isMRV ? 'img/logo_mrv.webp' : 'img/logo_sensia.png'}
            alt={isMRV ? 'im/logo_mrv.png' : 'img/logo_sensia.webp'}
          />
        </div>
        <div className={styles.titleContainer}>
          <h3>Simulador {isMRV ? 'MRV' : 'Sensia'}</h3>
        </div>
        <div className={styles.toggleContainer}>
          <ToggleSwitch
            id="companyToggle"
            isChecked={isMRV}
            onChange={onCompanyToggle}
            variant="split"
            onLabel="MRV"
            offLabel="Sensia"
          />
        </div>
      </div>
    </header>
  );
}

Header.propTypes = {
  isMRV: PropTypes.bool,
  onCompanyToggle: PropTypes.func.isRequired,
};

Header.defaultProps = {
  isMRV: true,
};

export default Header;
